import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { BaseModalComponent } from './base-modal.component';
import { Observable, Subject } from 'rxjs';

//USAGE
/*
 *   var modal = <models.BaseModalVM>{ isError: false, message: "ooooopsie 1" };
 *   var modal2 = <models.BaseModalVM>{ isError: true, message: "ooooopsie 2" };
 *   this.modalService.showModals([modal, modal2]).subscribe(result => console.log(result));
 * */


@Injectable({ providedIn: 'root' })
export class ModalService{
  modalRef: BsModalRef;
  currentModalindex: number = 0;
  modals: models.BaseModalVM[] = <models.BaseModalVM[]>[];
  result: Subject<boolean>;
  private _result: boolean;

  public hasShownSubscriberIntervention: boolean = false;

  constructor(private modalService: BsModalService) {
  }

  private onModalClosed(result: boolean) {
    //If already false stay false
    this._result = !this._result && this.currentModalindex != 0 ? false : result;
    if (++this.currentModalindex <= this.modals.length - 1)
      this.openModal(this.currentModalindex);
    else {
      
      this.result.next(this._result);
      
    }
    

  }

  private openModal(index: number) {
    var initialState = { modal: { ...(this.modals[this.currentModalindex]) } };
    (<any>document.activeElement).blur();
      this.modalRef = this.modalService.show(
        BaseModalComponent, { ignoreBackdropClick : true , initialState, class: 'modal-lg' });
      this.modalRef.content.onResult.subscribe(result => this.onModalClosed(result));
  }

  showModals(modals: models.BaseModalVM[]) : Observable<boolean> {
    this.currentModalindex = 0;
    this.result = new Subject();
    this.modals = modals;
    this.openModal(this.currentModalindex);
    return this.result.asObservable();
  }

 }
